import { gql } from '@apollo/client';

export const UPDATE_ENABLED = gql`
mutation MyMutation($Enabled:Boolean!,$OrganisationId: Int!) {
    update_msgbox_Organisation_many(updates: {where: {OrganisationId: {_eq: $OrganisationId}}, _set: {IsEnabled: $Enabled}}) {
      affected_rows
    }
  }`;
  